import { CustomerCartMetaStoreType } from "UidispatcherApiModule";
const { CustomerCartMetaStore }: { CustomerCartMetaStore: CustomerCartMetaStoreType } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export { CustomerCartMetaStore };
